<template>
    <div>
        <!-- display pages -->
        <slot/>
    </div>
</template>

<script>
export default {
    name: "Auth"
}
</script>
